import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ToastService } from 'src/app/shared/services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  private subject = new BehaviorSubject<string[]>([]);
  errors$ : Observable<string[]> = this.subject.asObservable()
                                       .pipe(
                                         filter(messages => messages && messages.length > 0 )
                                       );

  constructor(private toastService: ToastService) { }

  openSnackBar(message: string, action: string, duration = 6000, cssclass: string[] = null) {
    if (cssclass && cssclass.includes('error-snackbar')) {
      this.toastService.showError(message, duration || 12000);
    } else if (cssclass && cssclass.includes('success-snackbar')) {
      this.toastService.showSuccess(message, duration || 6000);
    } else {
      this.toastService.showMessage([message], duration || 12000);
    }
  }

  showError(message: string, duration: number = null){
    this.toastService.showError(message, duration || 12000);
  }

  showMessage(message: string, duration: number = null){
    this.toastService.showSuccess(message, duration || 6000);
  }

  showNeutralMessage(messages: string[]){
    this.toastService.showMessage(messages, 12000);
  }
}
